module.exports = __webpack_public_path__ + "assets/img/066401.03e8015a.svg";